<template>
	<div class="filter-chips">
		<v-tooltip v-for="chip in chips" :key="chip.key" :attach="overlayTarget" location="bottom">
			<template v-slot:activator="{ props: tooltipProps }">
				<v-chip v-bind="tooltipProps" :color="chip.kind === 'state' ? 'secondary' : 'primary'" :variant="chip.kind === 'state' ? 'outlined' : 'tonal'" closable class="filter-chips__chip" @click.stop="emit('select', chip.key)" @click:close.stop="emit('remove', chip.key)">
					<v-icon v-if="chip.kind === 'state'">block</v-icon>
					{{ chip.label }}
				</v-chip>
			</template>
			<span>{{ chip.fullLabel }}</span>
		</v-tooltip>
		<v-btn v-if="chips.length > 0" color="error" variant="tonal" rounded="xl" @click="emit('clear')">
			<v-icon>filter_alt_off</v-icon>
			{{ t('ClearAllFilters') }}
		</v-btn>
	</div>
</template>

<script setup>
import { inject } from 'vue';
import { useTranslator } from '@/composables/useTranslator';

// Chips are built by buildFilterChips() (src/utils/ui/filterChips.js) — this only renders them. `select`
// means "take me to that field" (the parent opens its filter panel and scrolls to it), `remove` means
// "reset that control", `clear` means "reset everything".
defineProps({
	chips: { type: Array, default: () => [] },
});
const emit = defineEmits(['select', 'remove', 'clear']);

const t = useTranslator();
const overlayTarget = inject('overlayTarget', null);
</script>
